import React from 'react'

const IconShapeArrow = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M4 20 20 4' />
         <path d='M9 4h11v11' />
      </svg>
   )
}
export default IconShapeArrow
